<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";

  .card {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;

    border-radius: 0.375rem;

    @include colors.background-color(aiSurfacePurple);

    padding: utils.in_rem(24px) utils.in_rem(24px);
    gap: utils.in_rem(16px);

    margin-top: 1.875rem;
    margin-bottom: 1.25rem;

    .header {
      display: flex;
      align-items: center;
      gap: utils.in_rem(8px);

      span {
        @include mixins.h4();
        @include colors.color(aiTextPurple);
      }
    }

    .body {
      display: flex;
      flex-direction: column;
      gap: utils.in_rem(16px);

      width: 100%;

      @include mixins.body2();
      @include colors.color(textBlack);
    }
  }
</style>

<script>
  import Icon from "@sourcewhale/shared/svelte-design-system/components/atoms/Icon.svelte";
  import { capitalizeFirstLetter } from "@sourcewhale/shared/src/assets/js/src/general/utils";
  import { todosModalItemStore } from "../stores";
  import AiTaskCardEmail from "./AiTaskCardEmail.svelte";
  import AiTaskCardTranscript from "./AiTaskCardTranscript.svelte";

  const icon = "fa-kit fa-ai-list";

  let kind = $derived($todosModalItemStore?.kind);
  let task = $derived($todosModalItemStore?.task || "");
  let origin = $derived($todosModalItemStore?.origin || "email");

  const snippetMap = {
    email: AiTaskCardEmail,
    call: AiTaskCardTranscript,
    meeting: AiTaskCardTranscript,
  };
</script>

{#if kind === "aiToDo"}
  <div class="card">
    <div class="header">
      <Icon class="{icon} color-aiIconPurple" size="medium" />
      <span>{capitalizeFirstLetter(task)}</span>
    </div>

    <div class="body">
      {@render snippetMap[origin]()}
    </div>
  </div>
{/if}
